// export const validateReason = (minChars, minWords) => ({
//     validator: (_, value) => {
//       const words = value.trim().split(/\s+/);
//       const characterCount = value.trim().length;
//       const wordCount = words.length;

//       if (characterCount < minChars || wordCount < minWords) {
//         return Promise.reject(
//           new Error(`Please justify the reason with at least ${minChars} characters and ${minWords} words`)
//         );
//       }
//       return Promise.resolve();
//     },
//   });

export const validateReason = (minChars, minWords, wordExists) => {
  return async (_, value) => {
    if (!value || typeof value !== "string") {
      return Promise.reject(new Error("Please enter a valid reason"));
    }

    const cleanedValue = value.replace(/[^a-zA-Z\s]/g, "").trim();
    const words = cleanedValue.split(/\s+/);
    const characterCount = cleanedValue.length;
    const wordCount = words.length;

    if (characterCount < minChars || wordCount < minWords) {
      return Promise.reject(
        new Error(
          `Please justify the reason with at least ${minChars} characters and ${minWords} words`
        )
      );
    }

    const allSame =
      words.length > 0 && words.every((word) => word === words[0]);
    if (allSame) {
      return Promise.reject(
        new Error("Please use meaningful and varied words")
      );
    }

    try {
      const wordChecks = await Promise.all(
        words.map((word) => wordExists(word.trim().toLowerCase()))
      );

      const invalidWords = wordChecks.filter((valid) => !valid);
      const validWords = wordChecks.filter((valid) => valid);

      if (validWords.length <= 0) {
        return Promise.reject(
          new Error("Please use atleast one valid English words in your reason")
        );
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(new Error("Validation failed. Please try again."));
    }
  };
};
